var moduleMap = {
	"./product-grid": () => {
		return __webpack_require__.e(/* product-grid */ "product-grid").then(() => (() => ((__webpack_require__("./src/exported/product-grid-wrapper/index.ts")))));
	},
	"./product-basic-info": () => {
		return __webpack_require__.e(/* product-basic-info */ "product-basic-info").then(() => (() => ((__webpack_require__("./src/exported/product-basic-info/index.ts")))));
	},
	"./product-brief": () => {
		return __webpack_require__.e(/* product-brief */ "product-brief").then(() => (() => ((__webpack_require__("./src/exported/product-brief/index.ts")))));
	},
	"./product-comparison-module": () => {
		return __webpack_require__.e(/* product-comparison-module */ "product-comparison-module").then(() => (() => ((__webpack_require__("./src/exported/product-comparison-module/index.ts")))));
	},
	"./product-cross-sell": () => {
		return __webpack_require__.e(/* product-cross-sell */ "product-cross-sell").then(() => (() => ((__webpack_require__("./src/exported/product-cross-sell/index.ts")))));
	},
	"./product-cta": () => {
		return __webpack_require__.e(/* product-cta */ "product-cta").then(() => (() => ((__webpack_require__("./src/exported/product-cta/index.ts")))));
	},
	"./product-full": () => {
		return __webpack_require__.e(/* product-full */ "product-full").then(() => (() => ((__webpack_require__("./src/exported/product-full/index.ts")))));
	},
	"./product-full-orderable": () => {
		return __webpack_require__.e(/* product-full-orderable */ "product-full").then(() => (() => ((__webpack_require__("./src/exported/product-full/index.ts")))));
	},
	"./product-media-carousel-nav": () => {
		return __webpack_require__.e(/* product-media-carousel-nav */ "product-media-carousel-nav").then(() => (() => ((__webpack_require__("./src/exported/product-image-nav-menu/index.ts")))));
	},
	"./product-quantity-selector": () => {
		return __webpack_require__.e(/* product-quantity-selector */ "product-quantity-selector").then(() => (() => ((__webpack_require__("./src/exported/product-quantity-selector/index.ts")))));
	},
	"./product-shade-picker": () => {
		return __webpack_require__.e(/* product-shade-picker */ "product-shade-picker").then(() => (() => ((__webpack_require__("./src/exported/product-shade-picker/index.ts")))));
	},
	"./product-size-picker": () => {
		return __webpack_require__.e(/* product-size-picker */ "product-size-picker").then(() => (() => ((__webpack_require__("./src/exported/product-size-picker-wrapper/index.ts")))));
	},
	"./product-shade-picker-button": () => {
		return __webpack_require__.e(/* product-shade-picker-button */ "product-shade-picker-button").then(() => (() => ((__webpack_require__("./src/exported/product-shade-picker-button/index.ts")))));
	},
	"./diContainer": () => {
		return Promise.all(/* diContainer */[__webpack_require__.e("vendors-node_modules_estee_elc-base-theme_src_ContentSpacing_ts-node_modules_estee_elc-servic-0cebfb"), __webpack_require__.e("vendors-node_modules_estee_elc-formatters_src_business-unit-id-parser_BusinessUnitIdParser_ts-aad9ca"), __webpack_require__.e("diContainer")]).then(() => (() => ((__webpack_require__("./src/service-setup/diContainer.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});